export const enum EngagementGridContainerPage {
	Admission = "admission",
	VolunteerRecruitment = "volunteer-recruitment",
	Volunteering = "volunteering",
	Experience = "experience",
	Delivery = "delivery",
}

// Starting enum values from 1 to avoid the default 0 (which is falsy)
export enum EngagementType {
	open = "open",
	closed = "closed",
	scheduledFollowUps = "scheduledFollowUps"
}
